import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import Tooltip from '@mui/material/Tooltip'
import SvgIcon from '@/modules/base/components/svg-icon/svg-icon'
import styles from './badge.css'

const useStyles = makeStyles((theme) => ({
  tooltip: {
    fontSize: theme.fontSizes.tooltip,
  },
  customColors: ({ backgroundColor, labelColor }) => ({
    ...(backgroundColor && { background: backgroundColor }),
    ...(labelColor && { color: labelColor }),
  }),
}))

const Badge = (props) => {
  const {
    color = 'white',
    label,
    customClass,
    icon,
    iconFill,
    customClassLabel,
    tooltip,
    iconWidth = '0.9rem',
    backgroundColor,
    labelColor,
  } = props
  const classes = useStyles({ backgroundColor, labelColor })
  const usePresetColor = !backgroundColor
  const useCustomColors = Boolean(backgroundColor || labelColor)

  const badge = (
    <div
      className={clsx(
        styles.container,
        usePresetColor && (styles[color] || styles.white),
        useCustomColors && classes.customColors,
        customClass,
      )}
    >
      {icon && <SvgIcon svg={icon} fill={iconFill} height={iconWidth} width={iconWidth} className={styles.icon} />}
      {label && (
        <label
          className={clsx(icon && styles.labelWithIcon, customClassLabel)}
          dangerouslySetInnerHTML={{ __html: label }}
        />
      )}
    </div>
  )

  return (
    tooltip
      ? (
        <Tooltip
          title={tooltip}
          disableHoverListener={!tooltip}
          classes={{
            tooltip: classes.tooltip || styles.tooltip,
          }}>
          {badge}
        </Tooltip>
      )
      : badge
  )
}
Badge.propTypes = {
  label: PropTypes.string,
  customClass: PropTypes.string,
  customClassLabel: PropTypes.string,
  color: PropTypes.oneOf(['primary', 'white', 'black', 'grey', 'blue', 'lightBlue', 'green', 'orange', 'red', 'purple', 'darkGrey', 'yellow', 'cyanMint']),
  icon: PropTypes.any,
  iconFill: PropTypes.string,
  tooltip: PropTypes.string,
  iconWidth: PropTypes.string,
  backgroundColor: PropTypes.string,
  labelColor: PropTypes.string,
}

export default Badge
